module.exports = __webpack_public_path__ + "static/media/gp-liaison-services-logo.83f332f8.png";